module.exports = __webpack_public_path__ + "img/image2.5cbf45cb.png";